import React from "react";
import "../Css/AboutsUs.css";
import Header from "../Components/Header";
import { Button, Divider } from "antd";
import MarqueeComponent from "../Components/Marquee/MarqueeComponent";
import Footer from "../Components/Footer";
import { IoCall } from "react-icons/io5";
import BannerComp from "../Components/BannerComp";
import aboutBanner from "../Assets/about-us.png";
import { Fade } from "react-awesome-reveal";
import productImg1 from "../Assets/ProductImages/Product Melee/20180731_124352.jpg";
import certifiedBanner from "../Assets/ProductImages/Certifed melee/WhatsApp Image 2024-10-08 at 11.38.51_841d9ad0.jpg";
import certifiedImg from "../Assets/ProductImages/Certified diamond/20210322_115204.jpg";
import { NavLink } from "react-router-dom";
import AboutPageComp from "../Components/AboutPageComp";
import HomeAboutUs from "../Components/HomeAboutUs";
import { MetaTags } from "react-meta-tags";

const AboutsUs = () => {
  const aboutConent = {
    paraOne: `Sejal Group, a name that spells Respect & Trust in our Industry, was incepted in the 1970's under the Able Guidance & Far Sighted Vision of <strong>Mr. Sevantibhai M. Shah</strong> and <strong>Mr. Chandubhai M. Shah</strong> . Our journey has been marked with unmatched quality and precision in small diamonds. Our Assurance of 'True Value Diamonds' reflects in the fact that we pay Paramount Attention to Every Detail of our Diamonds, right from Procurement to Processing to Delivery.`,
    paraTwo: `<strong>'Small Things Matter'</strong> has been appropriately incorporated and followed as our company's core ideology. The trust and faith of our clients has always made 'SeJal' a shining name in the diamond industry. Client-centric approach and policies and absolute transparency are some of the attributes that have helped us scale newer and higher horizons. We feel honored to serve you through these years, and your faith in our services is a testimony of our company's goodwill.`,
    paraThree: `Sejal Group assures you that it will be Our Constant Effort to Add Sparkle into Your Lives with ‘Our Values & Services’; Turning Precious Moments into Cherished Memories!`,
  };
  return (
    <>

      <MetaTags>
        <title>Best Diamonds Collection | Sejal Exports</title>
        <meta title="Best Diamonds Collection | Sejal Exports" />
        <meta name="description" content="Discover the Best Diamonds Collection featuring brilliant, high-quality diamonds perfect for any occasion. Find the ideal diamond for rings, necklaces, and more." />
        <meta name="keywords" content="Melee Diamonds For Jewellery,Best Diamonds Collection ,Diamond Wholesaler ,Fancy Color Diamonds ,Melee Diamonds,Certified Melee Diamonds,Fancy Diamonds With Different Shape,Black Diamonds ,Certified Diamonds,Customized Diamonds,Certified Fancy diamond,Natural Diamonds ,Calibrated Diamonds ,Best Ntural Diamond Supplier ,Best Natural Diamond Exhibition ,Best Natural Diamond Dealer,Reasonable Diamond In USA,Fast Delivery Diamonds ,High Quality Diamond In USA,Best Diamond Company In USA,Diamond For Jewelry In USA,cheapest Rate Diamond In USA,Natural Melee Diamond In USA,Reasonable Diamond In UK,Fast Delivery ,High Quality Diamond In UK,Best Diamond Company In UK,Diamond For Jewellery In UK,cheapest Rate Diamond In UK,Melee Diamond In UK,Reasonable Diamond In Canada,Fast Delivery ,High Quality Diamond In Canada,Best Diamond Company In Canada,Diamond For Jewellery In Canada,cheapest Rate Diamond In Canada,Melee Diamond In Canada,Reasonable Diamond In Australia,Fast Delivery ,High Quality Diamond In Australia,Best Diamond Company In Australia,Diamond For Jewellery In Australia,cheapest Rate Diamond In Australia,Melee Diamond In Australia,Reasonable Diamante In Mexico,Fast Delivery ,High Quality Diamante In Mexico,Best Diamante Company In Mexico,Diamante For joyas In Mexico,cheapest Rate Diamante In Mexico,Melee Diamante In Mexico,Reasonable Diamante In Columbia,Fast Delivery ,High Quality Diamante In Columbia,Best Diamante Company In Columbia,Diamante For joyas In Columbia,cheapest Rate Diamante In Columbia,Melee Diamante In Columbia,Reasonable Diamante In Italy,Fast Delivery ,High Quality Diamante In Italy,Best Diamante Company In Italy,Diamante For gioielli In Italy,cheapest Rate Diamante In Italy,Melee Diamante In Italy,Reasonable Diamant In France,Fast Delivery ,High Quality Diamant In France,Best Diamant Company In France,Diamant For bijoux In France,cheapest Rate Diamant In France,Melee Diamant In France,Reasonable Diamant In Germany,Fast Delivery ,High Quality Diamant In Germany,Best Diamant Company In Germany,Diamant For Schmuck In Germany,cheapest Rate Diamant In Germany,Melee Diamant In Germany,Reasonable diamant In Denmark,Fast Delivery ,High Quality diamant In Denmark,Best diamant Company In Denmark,diamant For Schmuck In Denmark,cheapest Rate diamant In Denmark,Melee diamant In Denmark,Reasonable diamant In Sweden,Fast Delivery ,High Quality diamant In Sweden,Best diamant Company In Sweden,diamant For smycke In Sweden,cheapest Rate diamant In Sweden,Melee diamant In Sweden,Reasonable Diamond In South Africa,Fast Delivery ,High Quality Diamond In South Africa,Best Diamond Company In South Africa,Diamond For Jewellery In South Africa,cheapest Rate Diamond In South Africa,Melee Diamond In South Africa,Reasonable Diamond In Hong Kong,Fast Delivery ,High Quality Diamond In Hong Kong,Best Diamond Company In Hong Kong,Diamond For Jewellery In Hong Kong,cheapest Rate Diamond In Hong Kong,Melee Diamond In Hong Kong,Reasonable Diamond In Dubai,Fast Delivery ,High Quality Diamond In Dubai,Best Diamond Company In Dubai,Diamond For Jewellery In Dubai,cheapest Rate Diamond In Dubai,Melee Diamond In Dubai,Reasonable Diamond In Malaysia,Fast Delivery ,High Quality Diamond In Malaysia,Best Diamond Company In Malaysia,Diamond For Jewellery In Malaysia,cheapest Rate Diamond In Malaysia,Melee Diamond In Malaysia,Reasonable Diamond In Singapore,Fast Delivery ,High Quality Diamond In Singapore,Best Diamond Company In Singapore,Diamond For Jewellery In Singapore,cheapest Rate Diamond In Singapore,Melee Diamond In Singapore,Reasonable Diamond In Thailand,Fast Delivery ,High Quality Diamond In Thailand,Best Diamond Company In Thailand,Diamond For Jewellery In Thailand,cheapest Rate Diamond In Thailand,Melee Diamond In Thailand,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia,Certified diamonds In India,Luxury diamonds In Dubai,Best Diamonds In Singapore ,Best Natural Diamond Dealer in Hong Kong,Diamond Dealer in Malaysia,Best Diamond Dealer in Thailand,Best Diamond Dealer in America,Best Diamond Dealer in United Kingdom,Best Diamond Dealer in Europe,Best Diamond Dealer in United State,Best Diamond Dealer in Australia" />
        <link rel="canonical" href="https://sejalexports.in/best-diamonds-collection" />
        <meta http-equiv="cache-control" content="no-cache" />
        <meta http-equiv="expires" content="0" />
        <meta http-equiv="pragma" content="no-cache" />
        <meta property="og:title" content="Best Diamonds Collection | Sejal Exports" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sejalexports.in/" />
        <meta property="og:description" content="Discover the Best Diamonds Collection featuring brilliant, high-quality diamonds perfect for any occasion. Find the ideal diamond for rings, necklaces, and more." />
        <meta property="og:image" content="https://sejalexports.in/static/media/logo.3d243a21eddc9f360630.png" />
      </MetaTags>

      <Header />
      <BannerComp
        title="About Us"
        breadcrumb={[
          {
            title: "Home",
            href: "/",
          },
          {
            title: "About Us",
          },
        ]}
        image={aboutBanner}
      />
      <HomeAboutUs aboutConent={aboutConent} />
      <AboutPageComp />
      <section
        className="home-about-us-se sectionDiv"
        style={{ background: "#eee" }}
      >
        <div className="container">
          <h3 className="text-center home-about-us-title ">
            PRODUCTS & SERVICES{" "}
          </h3>
          <div className="home-about-us-line-outer-ant">
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
            <div className="home-about-us-dot-ant">
              <label>•</label>
            </div>
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Fade triggerOnce direction="up">
                <p className="text-sm-center">
                  Sejal Group’ is a recognized wholesaler of loose diamonds from
                  sizes as small as 500 pcs/carat to 10 pcs/carat in large
                  quantities as per client's requirements.
                </p>
                <p className="text-sm-center">
                  We also deal in certified diamonds and aspire to serve the
                  smallest of client demands with the best customer-centric
                  policies. Stringent quality checks, both in human and
                  mechanical modes, have been set up across all levels of our
                  company structure to ensure that we deal only in 'true value,
                  natural diamonds'.
                </p>
                <p className="text-sm-center">
                  We constantly strive to adopt innovative and sustainable
                  technologies to improve the quality of our products. Our setup
                  helps us develop products where quality totally blends with
                  quantity at some of the most competitive prices the market can
                  offer.
                </p>
                <p className="text-sm-center">
                  Satisfied clients and workforce are a testimony of our
                  company's constant endeavor to be a center of excellence for
                  both products and people.
                </p>
              </Fade>
            </div>
          </div>
        </div>
      </section>
      {/* Our Promises start */}
      <section className="sectionDiv">
        <div className="container">
          <h3 className="text-center home-about-us-title my-3">Our Promise </h3>
          <div className="home-about-us-line-outer-ant">
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
            <div className="home-about-us-dot-ant">
              <label> •</label>
            </div>
            <div className="home-about-us-line-inner-ant">
              <Divider />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 mb-4">
              <Fade triggerOnce direction="left">
                <div className="shadow">
                  <div>
                    <span>
                      <img
                        alt="Best Diamonds Collection "
                        style={{
                          objectFit: "cover",
                          objectPosition: "center 30%",
                        }}
                        className="our-promise-img"
                        src={productImg1}
                      />
                    </span>
                  </div>
                  <div className="our-promise-discription">
                    <h4 className="our-promise-title mb-2 our-promise-discription-title">
                      {" "}
                      QUALITY
                    </h4>
                    <p className="our-promise-discription-para">
                      At Sejal Exports, we prioritize quality in our loose melee
                      diamonds. Each diamond undergoes rigorous grading for cut,
                      clarity, and color, ensuring exceptional brilliance and
                      value. Trust us to provide ethically sourced diamonds that
                      meet the highest industry standards.
                    </p>
                  </div>
                </div>
              </Fade>
            </div>

            <div className="col-lg-4 mb-4">
              <Fade triggerOnce direction="up">
                <div className="shadow h-100">
                  <div>
                    <span>
                      <img
                        alt="Best Diamonds Collection service"
                        style={{ minHeight: "250px" }}
                        className="our-promise-img"
                        src={certifiedBanner}
                      />
                    </span>
                  </div>
                  <div className="our-promise-discription">
                    <h4 className="our-promise-title mb-2 our-promise-discription-title">
                      {" "}
                      SERVICE
                    </h4>
                    <p className="our-promise-discription-para">
                      Sejal Exports offers unparalleled service for purchasing
                      loose melee diamonds. Our knowledgeable team provides
                      personalized assistance, guiding you through the selection
                      process. We prioritize customer satisfaction every step of
                      the way.
                    </p>
                  </div>
                </div>
              </Fade>
            </div>
            <div className="col-lg-4 mb-4">
              <Fade triggerOnce direction="right">
                <div className="shadow">
                  <div>
                    <span>
                      <img
                        alt="Diamonds Collection"
                        style={{ objectFit: "cover", objectPosition: "center" }}
                        className="our-promise-img"
                        src={certifiedImg}
                      />
                    </span>
                  </div>
                  <div className="our-promise-discription">
                    <h4 className="our-promise-title mb-2 our-promise-discription-title">
                      {" "}
                      INTEGRITY
                    </h4>
                    <p className="our-promise-discription-para">
                      At Sejal Exports, integrity is our cornerstone. We commit
                      to transparency and honesty in all transactions, ensuring
                      that our loose melee diamonds are ethically sourced and
                      accurately represented. Trust us to uphold the highest
                      ethical standards in the diamond industry.
                    </p>
                  </div>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section
        className="sectionDiv d-flex align-items-center justify-content-center"
        style={{
          background:
            "linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url('https://smartzonesuae.com/wp-content/uploads/2024/04/how-setup-diamond-trading-business-in-dubai-uae.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center center",
          minHeight: "60vh",
        }}
      >
        <div className="container d-flex align-items-center justify-content-center flex-column text-white">
          <Fade triggerOnce direction="down">
            <h2>Connect With Us</h2>
            <p style={{ maxWidth: "700px", textAlign: "center" }}>
              We value communication. Whether it's for inquiries or
              partnerships, feel free to connect with us through the available
              channels.
            </p>
            <NavLink to="/best-diamond-dealer">
              <Button
                style={{ borderRadius: 0, height: "45px", width: "150px" }}
                icon={<IoCall />}
              >
                Contact Us
              </Button>
            </NavLink>
          </Fade>
        </div>
      </section>
      {/* Visit us end */}
      <MarqueeComponent />
      <Footer />
    </>
  );
};

export default AboutsUs;
